import { sendGet } from "api/restUtil";
import { URL } from "pages/menu";

/**
 * URL에서 쿼리 문자열 파라미터를 읽는 함수
 * @param {String} name parsing할 데이터의 parameter key
 * @param {String} url default는 현재 url (location.href)
 * @returns Object형태
 */
export const getQueryParameterByName = ((name, url) => {
	if (!url) url = window.location.href;
	name = name.replace(/[\[\]]/g, "\\$&");
	const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
	const results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return "";
	return decodeURIComponent(results[2].replace(/\+/g, " "));
});

/**
 * 비교대상1(Array)가 비교대상2를 포함하고 있는지 확인
 * @param {Array} data1 비교대상1
 * @param {*} data2 비교대상2
 * @param {*} ignoreUndefined undefined인 데이터를 무시할지 여부
 * @returns 비교대상1이 비교대상2를 포함하고 있는지 여부
 */
export const isIncludes = (data1, data2, ignoreUndefined = false) => {
	if(data1 === null) return false;
	if(!Array.isArray(data1)) return false;
	return data1.some(d => isSame(d, data2, ignoreUndefined));
}

/**
 * Object 동일 여부
 * @param {*} data1 비교대상1
 * @param {*} data2 비교대상2
 * @param {boolean} ignoreUndefined undefined인 데이터를 무시할지 여부
 * @returns 두 비교대상이 동일한지 여부 true/false
 */
export const isSame = (data1, data2, ignoreUndefined = false) => {

	if(data1 === null && data2 === null) return true;
	if(data1 === null && data2 !== null) return false;
	if(data1 !== null && data2 === null) return false;

	// undefined를 무시하고, 비교대상이 둘다 Object이면, 비교를 위해 undefined인 데이터를 제거.
	if(ignoreUndefined && (typeof data1).toLowerCase() === "object" && (typeof data2).toLowerCase() === "object") {
		Object.keys(data1).forEach(d => {
			if(data1[d] === undefined) {
				delete data1[d];
			}
		});
		Object.keys(data2).forEach(d => {
			if(data2[d] === undefined) {
				delete data2[d];
			}
		});
	}

	if(Array.isArray(data1)) {
		// array
		if(!Array.isArray(data2)) {
			// 형식이 다름 (Array여부)
			return false;
		}
		if(data1.length !== data2.length) {
			// Array 길이가 다름
			return false;
		}

		for(let i=0; i<data1.length; i++) {
			const d1 = data1[i];
			const d2 = data2[i];
			if(!isSame(d1, d2, ignoreUndefined)) {
				// Array 값이 다름
				return false;
			}
		}
		return true;
	} else if((typeof data1).toLowerCase() === "object" ) {
		if((typeof data2).toLowerCase() !== "object") {
			// 형식이 다름
			return false;
		}
		// object
		if(Object.keys(data1).length !== Object.keys(data2).length) {
			// 키 개수가 다름
			return false;
		}
		
		const keys1 = Object.keys(data1);
		const keys2 = Object.keys(data2);
		for(let i=0; i<keys1.length; i++) {
			if(!keys2.includes(keys1[i])) {
				// data2에 keys1[i] 가 없음.
				return false;
			}
			const d1 = data1[keys1[i]];
			const d2 = data2[keys1[i]];

			if(!isSame(d1, d2, ignoreUndefined)) {
				// 키는 있는데 값이 다름.
				return false;
			}
		}

		return true;
	} else {
		// 데이터형은 무시하고 값만으로 비교
		return String(data1) === String(data2);
	}
}


/**
 * 값이 없으면 defaultValue를 반환. 값이 있으면 원래 값 반환
 * @param {*} value 
 * @param {*} defaultValue 
 * @returns 
 */
export const nvl = (value, defaultValue = "") => {
	if(value === undefined || value === null || value === "") {
		return defaultValue;
	} else {
		return value;
	}
}

/**
 * 값이 없으면 defaultValue를 반환. 값이 있으면 원래 값을 String 형태로 반환
 * @param {*} value 
 * @param {*} defaultValue 
 * @returns 
 */
export const nvlString = (value, defaultValue = "") => {
	if(value === undefined || value === null || value === "") {
		return defaultValue;
	} else {
		return String(value);
	}
}

/**
 * Object를 Get Parameter Type으로 변환
 * @param {Object} obj 
 * @returns key=value&key2=value2...
 */
export const objToParamStr = (obj) => {
	let result = "";
	const keys = Object.keys(obj);
	for(let i=0; i<keys.length; i++) {
		const key = keys[i];
		if(result !== "") {
			result += "&";
		}
		result += key + "=" + obj[key];
	}
	return result;
}


export const saveConfirm = () => {
	if(window.confirm("저장하시겠습니까?")) {
		return true;
	} else {
		return false;
	}
}
export const addConfirm = () => {
	if(window.confirm("추가하시겠습니까?")) {
		return true;
	} else {
		return false;
	}
}
export const modConfirm = () => {
	if(window.confirm("수정하시겠습니까?")) {
		return true;
	} else {
		return false;
	}
}

export const delConfirm = () => {
	if(window.confirm("삭제하시겠습니까?")) {
		return true;
	} else {
		return false;
	}
}

/**
 * 올바른 날짜 형태 인지 검증
 * @param {String} date 
 * @param {boolean} isNullable 
 * @returns 
 */
export function isValidDate(date, isNullable = true) {
	// nullable이고 입력 값이 없으면 true
	if(isNullable && date.length === 0) return true;
	// 10자리가 아니면 false
	if(date.length !== 10) return false;

	try {
		// 문자열을 날짜 형태로 변환
		let tmp = new Date();
		tmp.setFullYear(date.substring(0, 4));
		tmp.setMonth(date.substring(5,7)*1-1);
		tmp.setDate(date.substring(8,10));
		// 구분자
		let separator = date.substring(4, 5);
		// 변환된 날짜를 다시 문자열 형태로 변환
		const changedResult = tmp.getFullYear().toString() + separator + (tmp.getMonth()+1).toString().padStart(2, "0") + separator + tmp.getDate().toString().padStart(2, "0");
	
		// 변환된 날짜와 원래 날짜를 비교해서 동일한지 확인
		if (changedResult === date) return true;
		else return false;
	} catch(e) {
		// 오류 나면 false
		return false;
	}
}

/**
 * HH:mm 형태의 문자열이 올바른 형태인지 검증
 * @param {*} time 
 * @param {*} isNullable 
 * @returns 
 */
export function isValidHm(time, isNullable = true) {
	// nullable이고 입력 값이 없으면 true
	if(isNullable && time.length === 0) return true;
	// 5자리가 아니면 false
	if(time.length !== 5) return false;

	try {
		// 문자열을 날짜 형태로 변환
		let tmp = new Date();
		tmp.setHours(time.substring(0,2));
		tmp.setMinutes(time.substring(3,5));
		// 구분자
		let separator = time.substring(2, 3);

		if(separator !== ":") return false;	// 일단 HH:mm 으로 콜론 구분자만 허용.
		// 변환된 날짜를 다시 문자열 형태로 변환
		const changedResult = tmp.getHours().toString().padStart(2, "0") + separator + tmp.getMinutes().toString().padStart(2, "0")
	
		// 변환된 날짜와 원래 날짜를 비교해서 동일한지 확인
		if (changedResult === time) return true;
		else return false;
	} catch(e) {
		// 오류 나면 false
		return false;
	}

}

export function getTodayStr(separator = "-") {
	let today = new Date();
	return today.getFullYear().toString() + separator + (today.getMonth()+1).toString().padStart(2, "0") + separator + today.getDate().toString().padStart(2, "0");
}
// 월 더하기
export function getMonthAddStr(addMonth, separator, baseDt) {
	if(isEmpty(separator)) separator = "-";
	let today = baseDt ?? new Date();
	if((typeof today).toLowerCase() === "string") {
		today = new Date(today);
	}
	today.setMonth(today.getMonth() + (addMonth * 1));
	return today.getFullYear().toString() + separator + (today.getMonth()+1).toString().padStart(2, "0") + separator + today.getDate().toString().padStart(2, "0");
}
// 일 더하기
export function getDateAddStr(addDate, separator, baseDt) {
	if(isEmpty(separator)) separator = "-";
	let today = baseDt ?? new Date();
	if((typeof today).toLowerCase() === "string") {
		today = new Date(today);
	}
	today.setDate(today.getDate() + (addDate * 1));
	return today.getFullYear().toString() + separator + (today.getMonth()+1).toString().padStart(2, "0") + separator + today.getDate().toString().padStart(2, "0");
}
//해당 월 1일
export function getTodayMonthFirstStr(separator = "-"){
	let today = new Date();
	let todayMonthFirst = new Date(today.getFullYear(), today.getMonth(), 1);
	return today.getFullYear().toString() + separator + (todayMonthFirst.getMonth()+1).toString().padStart(2, "0") + separator + todayMonthFirst.getDate().toString().padStart(2, "0");
}
//해당 년도 1월 1일
export function getTodayYearFirstStr(separator = "-"){
	let today = new Date();
	return today.getFullYear().toString() + separator + "01-01";
}

// 현재 시각 HH:mm:ss.SSS
export function getNowTimeHmsS(separator = ":") {
	let today = new Date();
	return today.getHours().toString().padStart(2, "0") + separator +  today.getMinutes().toString().padStart(2, "0") + separator + today.getSeconds().toString().padStart(2, "0") + "." + today.getMilliseconds().toString();
}
// 현재 시각 HH:mm:ss
export function getNowTimeHms(separator = ":") {
	let today = new Date();
	return today.getHours().toString().padStart(2, "0") + separator +  today.getMinutes().toString().padStart(2, "0") + separator + today.getSeconds().toString().padStart(2, "0");
}
// 현재 시각 HH:mm
export function getNowTimeHm(separator = ":") {
	let today = new Date();
	return today.getHours().toString().padStart(2, "0") + separator +  today.getMinutes().toString().padStart(2, "0");
}

export function getDateStr(date, separator = "-") {
	return date.getFullYear().toString() + separator + (date.getMonth()+1).toString().padStart(2, "0") + separator + date.getDate().toString().padStart(2, "0");
}
export function getTimeHms(date, separator = ":") {
	return date.getHours().toString().padStart(2, "0") + separator +  date.getMinutes().toString().padStart(2, "0") + separator + date.getSeconds().toString().padStart(2, "0");
}

export function getCommaNumber (num) {
	const noCommaVal = String(num).replace(/,/g, "");
	let rtnVal = noCommaVal.split(".")[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	if(noCommaVal.includes(".")) {
		rtnVal += ".";
		// rtnVal += noCommaVal.split(".")[1].replace(/\B(?=(\d{3})+(?!\d))/g, ",");;
		rtnVal += noCommaVal.split(".")[1];
	}
	return rtnVal;
}

// 기안 작성 폼 열기
export function openDraftFormPopup(sendData, name = "draftForm") {
	const width = 1400;
	const height = 800;
	const left = window.screen.width / 2 - width / 2;
	const top = window.screen.height / 2 - height / 2;
	const windowFeatures = `width=${width},height=${height},left=${left},top=${top},toolbar=no,menubar=no,location=no,status=no,resizable=yes,scrollbars=yes`;
	const url = `${URL.DRAFT_FORM}?data=${encodeURIComponent(JSON.stringify(sendData))}`;
	window.open(url, name, windowFeatures);
}
// 기안 보기 열기
export function openDraftViewPopup(sendData, name = "draftForm") {
	const width = 1400;
	const height = 800;
	const left = window.screen.width / 2 - width / 2;
	const top = window.screen.height / 2 - height / 2;
	const windowFeatures = `width=${width},height=${height},left=${left},top=${top},toolbar=no,menubar=no,location=no,status=no,resizable=yes,scrollbars=yes`;
	const url = `${URL.DRAFT_VIEW}?data=${encodeURIComponent(JSON.stringify(sendData))}`;
	window.open(url, name, windowFeatures);
}

// 페이지 번호 체크.
export async function checkPagingData(data, searchList, cond) {
	if(data.list.length === 0 && data.totalCnt > 0) {
		// 데이터는 없는데 전체 건수가 있는건 페이징에 문제 (마지막페이지 1건을 삭제했다거나 하는..)
		// 현재 데이터의 마지막 페이지 번호 계산
		let maxPageNo = Math.floor(data.totalCnt / data.cntPerPage);	// 페이지 개수
		const maxPageNoRemainder = data.totalCnt % data.cntPerPage;	// 나머지
		
		// 나머지가 있으면 페이지개수 +1
		if(maxPageNoRemainder > 0) {
			maxPageNo += 1;
		}

		// 마지막 페이지로 다시 조회
		cond.pageNo = maxPageNo;
		searchList(cond);
		return false;
	} else {
		return true;
	}
}
// Dttm에서 초 제거
export function removeSeconds(dateStr) {
	if(dateStr === null || dateStr === "") return null;
	let date = new Date(dateStr);

	const dt = date.getFullYear() + "-" + (date.getMonth()+1).toString().padStart(2, "0") + "-" + date.getDate().toString().padStart(2, "0");
	const tm = date.getHours().toString().padStart(2, "0") + ":" + date.getMinutes().toString().padStart(2, "0");
	return dt + "  " + tm;
}
// Dttm 에서 시간 제거
export function removeTime(dateStr) {
	if(dateStr === null || dateStr === "") return null;
	let date = new Date(dateStr);

	const dt = date.getFullYear() + "-" + (date.getMonth()+1).toString().padStart(2, "0") + "-" + date.getDate().toString().padStart(2, "0");
	return dt;

}

/**
 * 문자열 EmptyCheck
 * @param {String} str 
 * @param {Boolean} spaceIgnore 공백 무시 여부, true로 설정하면 공백은 값이 없는 것으로 처리. default는 false.
 * @returns 
 */
export function isEmptyStr(str, spaceIgnore = false) {
	if(str === null || typeof str === "undefined") return true;
	if(spaceIgnore) {
		return str.trim() === "";
	} else {
		return str === "";
	}
}

/**
 * 배열 EmptyCheck. null 및 length 체크
 * @param {Array} array 
 * @param {Boolean} checkChild 자식 체크 여부. false이면 length만 체크, true 이면 자식들의 length나 값여부까지 체크.
 * @returns 
 */
export function isEmptyArray(array, checkChild = false) {
	if(array === null || (typeof array).toLowerCase() === "undefined") return true;
	if(array.length === 0) return true;
	if(checkChild) {
		const isNotEmpty = array.some(d => !isEmpty(d, checkChild));	// empty가 아닌게 하나라도 있는지
		return !isNotEmpty;
	} else {
		return false;
	}
}

/**
 * Object EmptyCheck. null 및 하위 데이터 값 존재 여부
 * @param {*} obj 
 * @param {Boolean} checkChild 자식 체크 여부. false이면 key개수만 체크, true 이면 자식들의 length나 값여부까지 체크.
 * @returns 
 */
export function isEmptyObj(obj, checkChild = false) {
	if(obj === null || (typeof obj).toLowerCase() === "undefined") return true;
	const keys = Object.keys(obj);
	if(keys.length === 0) return true;
	let result = true;
	for(let key of keys) {
		if(!isEmpty(obj[key], checkChild)) {
			result = false;
			break;
		}
	}
	return result;
}

export function isEmpty(data, strSpaceIgnore = false, checkChild = false) {
	if(data === null || (typeof data).toLowerCase() === "undefined") return true;
	if(Array.isArray(data)) {
		return isEmptyArray(data, checkChild);
	} else if((typeof data).toLowerCase() === "object") {
		return isEmptyObj(data, checkChild);
	} else {
		return isEmptyStr(data, strSpaceIgnore);
	}
}

/**
 * 시작일~종료일의 주말,공휴일을 제외한 근무일수.
 * @param {*} startDt yyyy-MM-dd or yyyy.MM.dd or yyyy/MM/dd
 * @param {*} endDt yyyy-MM-dd or yyyy.MM.dd or yyyy/MM/dd
 */
export async function getWorkDayCnt(startDt, endDt) {
	const result = await sendGet("/api/work-day-cnt", {startDt: startDt, endDt: endDt});
	if(result.respCode === "SUCCESS") {
		return result.data;
	} else {
		return null;
	}
}

//휴일 포함 일수
export function getDaycnt(startDt, endDt) {
	const date1 = new Date(startDt);
	const date2 = new Date(endDt);

	const diffDate = date2.getTime() - date1.getTime();

	return Math.abs(diffDate / (1000*60*60*24)) + 1;
}


export const getIsoDateToDisplay = (isoDate) => {
	const date = new Date(isoDate);
	const result = getDateStr(date) + " " + getTimeHms(date);
	return result;
}


export const getDateToIsoDate = (dateStr) => {
	const date = new Date(dateStr);
	// const timezoneOffsetMinute = date.getTimezoneOffset();	// 분 단위의 timezome offset(한국은 +09:00이므로 -540).
	const timezoneOffsetMinute = -540;	// 무조건 한국 시각을 기준으로 처리 하는 걸로...
	const timezoneOffset = timezoneOffsetMinute * 60 * 1000;	// milliseconds 단위로 변경
	// 한국 시각을 기준으로 계산
	const tmpDate = new Date(date.getTime() - timezoneOffset);
	// iso 문자열 형태로 변환
	const isoString = tmpDate.toISOString().replace("Z", "+09:00");
	return isoString;
}

/**
 * 에디터 내용 가져오기
 * @param {*} iframeId 
 * @returns 
 */
export function getEditorContent(iframeId) {
	if(isEmpty(iframeId)) {
		iframeId = "smartEditor_iframe_container";
	}
	return document.getElementById(iframeId).contentWindow.getContent();
}